import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=90973d8c&"
import script from "./AlertBox.vue?vue&type=script&lang=ts&"
export * from "./AlertBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports